// "We Search For You" page specific translations - English
export const weSearchForYouEn = {
  hero: {
    title: 'Car Finder',
    description:
      "Can't find the car you're looking for? We find it for you and notify you when we have options that match your needs.",
  },
  form: {
    criteriaTitle: 'Search Criteria',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    brand: 'Brand',
    brandPlaceholder: 'Select a brand',
    model: 'Model',
    modelPlaceholder: 'Select a model',
    yearFrom: 'Year from',
    yearTo: 'Year to',
    yearFromPlaceholder: 'e.g., 2018',
    yearToPlaceholder: 'e.g., 2023',
    maxMileage: 'Maximum mileage',
    maxMileagePlaceholder: 'e.g., 50000',
    maxOwners: 'Maximum owners',
    maxOwnersPlaceholder: 'e.g., 2',
    budget: 'Budget',
    budgetPlaceholder: 'e.g., 15,000,000',
    message: 'Additional details',
    messagePlaceholder: 'Tell us more about what you’re looking for...',
    submit: 'Request Search',
  },
  info: {
    howItWorksTitle: 'How Does Our Service Work?',
    processTitle: 'Our process',
    processList: {
      step1: 'Send your request with specific criteria',
      step2: 'We receive and register your request',
      step3: 'We actively search across our market',
      step4: 'We contact you when we find options',
      step5: 'You schedule a visit and vehicle evaluation',
      step6: 'You complete the purchase if satisfied',
    },
    advantagesTitle: 'Service advantages',
    advantagesList: {
      item1: 'Personalized search based on your criteria',
      item2: 'Access to vehicles not publicly listed',
      item3: 'Pre-evaluated quality checks',
      item4: 'Professional negotiation',
      item5: 'No additional service cost',
      item6: 'Specialized advisory',
    },
    directContactTitle: 'Direct Contact',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    tipTitle: 'Helpful tip',
    tipText:
      'The more specific your criteria, the better we can find the ideal vehicle for you. Feel free to add more details in the message.',
  },
  successMessage:
    'Search request sent successfully! We will contact you soon when we have options that match your criteria.',
  embed: {
    infoTitle: 'How does it work?',
    steps: [
      { title: 'Tell us what you need', desc: 'Fill out the form with your preferences and budget.' },
      { title: 'We search for you', desc: 'Our team searches across our entire supplier network.' },
      { title: 'We show you options', desc: 'We present the best alternatives we found.' },
      { title: 'Safe purchase', desc: 'We manage the purchase with mechanical inspection included.' },
    ],
    benefitsTitle: 'Benefits',
    benefits: ['Personalized search', 'Access to supplier network', 'Mechanical inspection included', 'Satisfaction guaranteed'],
  },
};

